import { ComponentProps } from '@/lib/component-props';
import { OasBaseProps } from '@/types/OasBaseProps';

export type AutocompleteSearchRequest = {
  input: string;
  coid: string;
  program: string;
  LocationLatitude?: string;
  LocationLongitude?: string;
  Radius?: string;
  LocationUrlTitle?: string;
};

type CategoryBase = {
  value: string;
  reference: string;
  imgSrc: string | null;
};

type Provider = CategoryBase & {
  type: 'provider';
};

type Specialty = CategoryBase & {
  type: 'specialty';
};

type Location = CategoryBase & {
  type: 'location';
};

type VisibleTerm = CategoryBase & {
  type: 'webVisibleKeyword';
};

type AutocompleteCategory = Provider | Specialty | Location | VisibleTerm;

export enum AutocompleteCategories {
  locations = 'locations',
  providers = 'providers',
  specialties = 'specialties',
  visibleTerms = 'visibleTerms',
}

export enum AutocompleteQueries {
  keywordExact = 'keywordExact',
  locationUrlTitle = 'locationUrlTitle',
  specialtyId = 'specialtyId',
  keywords = 'keywords',
}

export type AutocompleteCategoryList = AutocompleteCategory[];

export type AutocompleteItems = {
  providers: AutocompleteCategoryList;
  specialties: AutocompleteCategoryList;
  locations: AutocompleteCategoryList;
  visibleTerms: AutocompleteCategoryList;
};

export type AutocompleteResponse = {
  data: AutocompleteItems;
};

export type ProviderSearchFields = OasBaseProps & {
  notFound: boolean;
  physiciansCount?: number;
  locationUrlTitle?: string;
  isMho?: boolean;
};

export type ProvidersSearchProps = ComponentProps & { fields: ProviderSearchFields };
export interface ProvidersInputRef {
  clear: () => void;
}
